import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrManager } from 'ng6-toastr-notifications';
import { TableUtil } from '../tableUtil';
import { emailNotificationText } from '../models/emailNotificationText';
import { CucurachaAdminService } from '../service/cucuracha.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-emailnotificationttextmanagement',
  templateUrl: './emailnotificationttextmanagement.component.html',
  styleUrls: ['./emailnotificationttextmanagement.component.css']
})
export class EmailnotificationttextmanagementComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("emailNotificationText") form: any;
  @ViewChild("emailNotificationTextUpdate", { static: true }) formUpdate: any;
  editor = ClassicEditor;

  emailNotificationTextAddObj: emailNotificationText
  dataSource: any;
  displayedColumns = ['notificationType', 'notificationTitle', 'notificationTextDescription','status', 'Action']
  userDetails: any;
  userSessionData: any
  read: any;
  write: any;
  delete: any
  show: boolean = false

  constructor(private cs: CucurachaAdminService, private toastr: ToastrManager) {
    this.emailNotificationTextAddObj = new emailNotificationText();

  }
  addAppNotificationText() {
    if (this.show == false) {
      this.show = true
      this.form.reset();
      this.formUpdate.reset()

    }
    else {
      this.show = false
      this.form.reset()
      this.formUpdate.reset()


    }
  }
  onChange(status, id) {
    console.log(status.checked)
    this.cs.getByEmailNotificationTextId(id).subscribe((data) => {
      this.emailNotificationTextAddObj._id = data[0]._id;

      this.emailNotificationTextAddObj.notificationType = data[0].notificationType
      this.emailNotificationTextAddObj.notificationTitle = data[0].notificationTitle
      this.emailNotificationTextAddObj.notificationTextDescription = data[0].notificationTextDescription


      this.emailNotificationTextAddObj.status = status.checked;

      this.cs.updateEmailNotificationTextstatus(this.emailNotificationTextAddObj).subscribe((data) => {
        if (data.result) {
          this.ngOnInit();
          this.toastr.successToastr(data.message);
          this.form.reset();
          this.formUpdate.reset();

        }
        else if (data.err) {
          this.toastr.warningToastr(data.message);
          this.ngOnInit();


        }
        else {
          this.toastr.errorToastr(data.message);
          this.ngOnInit();


        }
      })
    })
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  saveEmailNotificationTexts() {
    this.cs.saveEmailNotificationTexts(this.emailNotificationTextAddObj).subscribe((data) => {

      if (data.result) {
        this.getAllEmailNotificationTexts();
        this.toastr.successToastr(data.message);
        this.form.reset();

      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    });

  }
  getAllEmailNotificationTexts() {
    this.cs.getAllEmailNotificationTexts().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }
  getByEmailNotificationTextId(id: any) {
    this.cs.getByEmailNotificationTextId(id).subscribe((data) => {
      this.emailNotificationTextAddObj._id = data[0]._id;
      this.emailNotificationTextAddObj.notificationType = data[0].notificationType
      this.emailNotificationTextAddObj.notificationTitle = data[0].notificationTitle
      this.emailNotificationTextAddObj.notificationTextDescription = data[0].notificationTextDescription

    })
  }
  updateEmailNotificationText() {
    this.cs.updateEmailNotificationText(this.emailNotificationTextAddObj).subscribe((data) => {
      if (data.result) {
        this.getAllEmailNotificationTexts();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();
      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);
      }
      else {
        this.toastr.errorToastr(data.message);
      }
    })
  }
  deleteEmailNotificationText(id: any) {
    this.cs.deleteEmailNotificationText(id).subscribe((data) => {
      this.getAllEmailNotificationTexts()
      this.toastr.warningToastr("Data Deleted");
    })

  }
  ngOnInit(): void {
    this.getAllEmailNotificationTexts();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))
    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
      this.read = (this.userDetails.roledetails[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].read);
      this.write = (this.userDetails.roledetails[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].write)
      this.delete = (this.userDetails.roledetails[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].delete)
    })

  }

}
